import Input from "./Input.js";
const variants = {
    outline: (props) => Input.variants.outline(props).field ?? {},
};
const defaultProps = {
    variant: "outline",
};
const Textarea = {
    variants,
    defaultProps,
};
export default Textarea;
